import type { CityConfig } from "@/pages/city-template/types";

export const aikenConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — SC DHEC Vital Records", href: "https://scdhec.gov/vital-records", description: "Official South Carolina vital records office in Columbia" },
    { label: "Marriage Licenses — Aiken County Probate Court", href: "https://www.aikencountysc.gov/", description: "Aiken County Probate Court — marriage license issuance" },
    { label: "Divorce Records — Aiken County Clerk of Court", href: "https://www.aikencountysc.gov/", description: "Aiken County Clerk of Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of SC DHEC for online vital record orders" },
  ],
  city: "Aiken",
  state: "South Carolina",
  stateAbbr: "SC",
  slug: "aiken",
  route: "/cities/aiken",
  title: "Emergency Passport Aiken, SC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Aiken, SC — as fast as 24 hours. No Aiken passport agency. Fast Passport Center couriers to the Atlanta Passport Agency at 230 Peachtree St NW. A+ BBB rated. Serving equestrian community travelers, USC Aiken students, Savannah River Site professionals, and Aiken County families.",
  h1: "Emergency & Expedited Passport Services in Aiken, SC",
  heroSubtitle: "Aiken is South Carolina's equestrian heartland, a charming historic city just 20 miles from Augusta, Georgia. Fast Passport Center's registered couriers deliver your documents to the Atlanta Passport Agency at 230 Peachtree St NW so you get a new or renewed passport as fast as 24 hours — whether you're an equestrian competitor heading to international horse shows in Europe, a USC Aiken student preparing for study abroad, a Savannah River Site contractor on global assignment, or an Aiken County family planning an overseas vacation.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aiken%20South%20Carolina%20historic%20downtown%20district%20with%20tree-lined%20Laurens%20Street%20featuring%20beautifully%20preserved%20brick%20storefronts%20and%20the%20iconic%20Aiken%20train%20depot%20with%20horse-and-carriage%20ambiance%2C%20live%20oak%20trees%20draped%20in%20Spanish%20moss%20framing%20elegant%20southern%20architecture%20during%20warm%20golden%20hour%2C%20equestrian%20heritage%20town%20with%20charming%20streetscape%20and%20historic%20charm&width=1800&height=700&seq=aiken-sc-hero-001&orientation=landscape",
  heroImageAlt: "Aiken South Carolina historic downtown with Laurens Street and live oaks at golden hour",
  geoPosition: "33.5609;-81.7192",
  geoPlacename: "Aiken, South Carolina",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
    distance: "Approximately 155 miles from Aiken — about 2 hours 30 minutes via I-20",
  },
  nearbyCitiesZips: [
    { name: "Aiken", zips: "29801, 29803" },
    { name: "North Augusta", zips: "29841, 29860" },
    { name: "Augusta", zips: "30901, 30904, 30909" },
    { name: "Edgefield", zips: "29824" },
    { name: "Graniteville", zips: "29829" },
    { name: "Warrenville", zips: "29851" },
    { name: "New Ellenton", zips: "29809" },
    { name: "Jackson", zips: "29831" },
    { name: "Barnwell", zips: "29812" },
    { name: "Williston", zips: "29853" },
    { name: "Bamberg", zips: "29003" },
    { name: "Johnston", zips: "29832" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Courier delivery to Atlanta Passport Agency — only 155 miles from Aiken via I-20" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-map-pin-2-line", title: "CSRA & Horse Country", desc: "Serving Aiken, North Augusta, Edgefield, Graniteville, and the CSRA" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Aiken case from start to finish" },
  ],
  internalLinks: [
    { name: "Emergency passport in Charleston SC", route: "/cities/charleston" },
    { name: "Expedited passport in Columbia SC", route: "/cities/columbia-sc" },
    { name: "Urgent passport in Aiken SC", route: "/cities/aiken" },
    { name: "South Carolina passport hub", route: "/states/south-carolina" },
    { name: "Fast passport in Greenville SC", route: "/cities/greenville-sc" },
    { name: "Expedited passport in Augusta GA", route: "/augusta" },
    { name: "Emergency passport in Summerville SC", route: "/cities/summerville" },
  ],
  fpcOfficeAddress: "230 Peachtree St NW, Suite 1000, Atlanta, GA 30303",
  fpcOfficeNote: "Fast Passport Center serves Aiken remotely via secure courier. Our registered couriers hand-deliver your documents to the Atlanta Passport Agency at 230 Peachtree St NW — approximately 155 miles away. Aiken's location directly on I-20 between Augusta and Atlanta makes overnight courier routing exceptionally efficient. Only 2.5 hours to the agency by road — but our courier service means Aiken residents never need to make the drive themselves.",
  fpcOfficeDistance: "Serving all of Aiken County and the CSRA",
  serviceAreaIntro: "Fast Passport Center provides emergency and fast passport renewal services throughout Aiken, North Augusta, Edgefield, Graniteville, and the Central Savannah River Area. From USC Aiken students heading abroad to SRS contractors on international assignment, we help Aiken County travelers get their passports fast.",
  nearbyCitiesIntro: "We serve Aiken and nearby communities including North Augusta, Edgefield, Graniteville, Warrenville, New Ellenton, and the greater CSRA region.",
  howItWorksIntro: "Most Aiken travelers complete everything online and ship documents overnight. At only 155 miles from Atlanta, Fast Passport Center provides the fastest courier turnaround in the Midlands — eliminating the 2.5-hour drive to the Atlanta Passport Agency.",
  mistakesIntro: "Aiken travelers, including equestrian competitors, Savannah River Site professionals, and USC Aiken students studying abroad, face unique passport challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Aiken and CSRA travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Aiken? Here are the most common ones we hear from equestrian, university, and SRS travelers.",
  statePageRoute: "/states/south-carolina",
  statePageName: "South Carolina",
  dmvWebsite: "https://www.scdmvonline.gov/",
  dmvLabel: "South Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "No drive or appointment needed",
        "Ideal for equestrian competitors heading abroad",
        "Perfect for SRS contractor global assignments",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service USPS",
        "Good for planned travel from AGS",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "No document review — errors cause rejection",
        "In-person clerk appointment required",
        "Workload shifts with government shutdowns",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "Cannot upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins at 230 Peachtree St NW",
        "Life-or-death emergencies only",
        "155 miles to Atlanta (2 hours 30 minutes via I-20)",
        "Still requires pre-scheduled NPIC appointment",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "Aiken is only 155 miles from the Atlanta Passport Agency — our courier service is the fastest in the Midlands.",
      bullets: ["CSRA region coverage", "24–48 hour turnaround available", "No appointment or drive needed"],
      badge: "Fastest in Midlands",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Aiken adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No acceptance clerk visit for most renewals", "Mail-in or courier options", "Serving Aiken and Aiken County"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support in Aiken and Aiken County.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Fast replacement for Aiken, North Augusta, and CSRA residents with DS-64 form guidance.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement via Atlanta agency"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support in Aiken County.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport name change service after marriage, divorce, or legal changes for Aiken and CSRA residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Aiken SC", description: "Urgent passport processing for Aiken, SC travelers via Atlanta Passport Agency courier — only 155 miles from Aiken." },
    { name: "Passport Renewal Aiken SC", description: "Fast passport renewal for Aiken and Aiken County, South Carolina residents." },
    { name: "New Passport Aiken SC", description: "First-time passport application assistance for Aiken and CSRA area residents." },
    { name: "Lost Passport Aiken SC", description: "Passport replacement for lost or stolen passports for Aiken and CSRA residents." },
    { name: "Child Passport Aiken SC", description: "Minor passport services for Aiken and Aiken County families." },
    { name: "Name Change Passport Aiken SC", description: "Passport name change service for Aiken, SC residents." },
  ],
  testimonials: [
    {
      name: "Katherine V.",
      location: "Aiken Equestrian Competitor",
      rating: 5,
      text: "I compete in show jumping and was selected for an international competition in Wellington, UK, with 10 days notice. My passport had less than 3 months validity — not enough for UK entry. Fast Passport Center expedited the renewal in 3 business days. Made the competition. Their team understood the urgency of the equestrian calendar.",
      service: "Emergency Renewal",
    },
    {
      name: "Daniel S.",
      location: "Savannah River Site Contractor",
      rating: 5,
      text: "SRS project manager called to an IAEA safeguards meeting in Vienna with 8 days notice. Passport had expired. Fast Passport Center handled the renewal with priority courier through Atlanta. Passport arrived in 2 business days. Professional service that understands DOE contractor clearance requirements.",
      service: "Emergency Business Renewal",
    },
    {
      name: "Amanda C.",
      location: "USC Aiken Student",
      rating: 5,
      text: "USCA education major accepted to a student teaching program in Dublin, Ireland. Realized 3 weeks before the program started that I needed a first-time passport. Fast Passport Center walked me through the entire process. Had my passport in 6 business days. My agent was so patient — couldn't have done it without them.",
      service: "First-Time Passport",
    },
    {
      name: "Robert & Mary H.",
      location: "North Augusta, SC",
      rating: 5,
      text: "CSRA couple planning a River Cruise from Budapest to Amsterdam for our retirement celebration. Both passports had expired during the pandemic. Fast Passport Center handled both renewals simultaneously — received them in 7 business days. The peace of mind was worth every penny.",
      service: "Dual Renewal",
    },
  ],
  facilities: [
    {
      id: "aik-1",
      name: "Aiken Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "307 Laurens St SW",
      city: "Aiken",
      state: "SC",
      zip: "29801",
      phone: "(803) 648-7451",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Aiken — Downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Aiken and Aiken County residents. Appointment required. Located on Laurens Street in the historic downtown district near the Aiken train depot.",
      icon: "ri-mail-line",
    },
    {
      id: "aik-2",
      name: "Aiken County Clerk of Court",
      type: "County Clerk Passport Acceptance",
      address: "109 Park Ave SE",
      city: "Aiken",
      state: "SC",
      zip: "29801",
      phone: "(803) 642-1715",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Aiken — Downtown",
      website: "https://www.aikencountysc.gov/",
      websiteLabel: "Aiken County Government",
      notes: "County clerk passport acceptance services in the Aiken County Judicial Center. Convenient downtown location near the Aiken County Courthouse. Often less crowded than the post office.",
      icon: "ri-government-line",
    },
    {
      id: "aik-3",
      name: "North Augusta Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1450 Georgia Ave",
      city: "North Augusta",
      state: "SC",
      zip: "29841",
      phone: "(803) 279-9781",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "North Augusta — 14 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for North Augusta and southern Aiken County residents near the Georgia border. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "aik-4",
      name: "Edgefield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "325 Main St",
      city: "Edgefield",
      state: "SC",
      zip: "29824",
      phone: "(803) 637-6214",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Edgefield — 24 miles southwest",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Edgefield County and western Aiken County residents. Small-town post office — call ahead to confirm current hours.",
      icon: "ri-mail-line",
    },
    {
      id: "aik-5",
      name: "Graniteville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Canal St",
      city: "Graniteville",
      state: "SC",
      zip: "29829",
      phone: "(803) 663-9327",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Graniteville — 8 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for eastern Aiken County residents in the Graniteville and Warrenville areas. Call ahead — limited hours may vary.",
      icon: "ri-mail-line",
    },
    {
      id: "aik-6",
      name: "Barnwell Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "221 Main St",
      city: "Barnwell",
      state: "SC",
      zip: "29812",
      phone: "(803) 259-3115",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Barnwell — 32 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Barnwell County and southern Aiken County residents. Appointment recommended.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Distance to Atlanta Agency", agency: "155 miles — 2 hour 30 minute drive on I-20, but need appointment", fpc: "We drive for you — no appointment needed" },
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Student Support", agency: "No — generic government service", fpc: "Yes — military PCS & USC Aiken study abroad expertise" },
    { feature: "Equestrian Travel Knowledge", agency: "No — no specialized travel knowledge", fpc: "Yes — international horse show documentation guidance" },
  ],
  mistakes: [
    {
      icon: "ri-trophy-line",
      title: "Equestrian Competitors Not Planning for International Show Seasons",
      description: "Aiken's equestrian community travels to international competitions in the UK, Germany, Netherlands, and beyond. Horse show seasons run year-round, and competitors often book events months in advance without checking passport validity. An expired passport can mean missing a qualifying event or championship.",
    },
    {
      icon: "ri-shield-line",
      title: "SRS Contractors Confusing DOE Clearance With Passport Validity",
      description: "Savannah River Site contractors sometimes assume their DOE security clearance covers international travel requirements. A DOE clearance is not a passport or visa. SRS professionals traveling to IAEA meetings, international conferences, or overseas site visits must maintain valid personal passports — completely separate from DOE credentials.",
    },
    {
      icon: "ri-calendar-line",
      title: "USC Aiken Students Waiting Until Finals Week",
      description: "USC Aiken students accepted to study abroad programs in Europe, Asia, or Central America often delay passport applications until finals week — just weeks before departure. Summer study abroad programs require passport applications in March, not late April or May. Late applications create unnecessary stress during exam season.",
    },
    {
      icon: "ri-flag-line",
      title: "CSRA Residents Confusing Georgia and South Carolina DMV Rules for Passport ID",
      description: "The CSRA spans the SC-GA border, and Aiken residents who also work in Augusta sometimes confuse which state's driver's license they need. For passport applications, you need valid government-issued ID — a South Carolina REAL ID, Georgia REAL ID, or other federally accepted ID. Expired or out-of-state IDs cause application rejections.",
    },
    {
      icon: "ri-image-line",
      title: "Using Horse Show Photos or Self-Taken Photos as Passport Photos",
      description: "Aiken equestrian competitors sometimes try to use professional horse show photos or smartphone selfies as passport photos. Passport photos must be exactly 2x2 inches with a pure white background, neutral expression with eyes open, and absolutely no hats, sunglasses, or equestrian attire. Only professional passport photo services meet the strict State Department standards.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Country-Specific Entry Requirements for Equestrian Events",
      description: "International equestrian events in the UK, EU, Middle East, and Asia each have different entry requirements. The UK requires 6 months passport validity, while Schengen countries require 3 months beyond planned departure. Some Middle Eastern countries require 6 months. Aiken competitors must check specific destination requirements for each event.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send a prepaid overnight label. Drop at any UPS location in Aiken, North Augusta, or downtown Augusta." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team reviews every document, then couriers to the Atlanta Passport Agency — only 155 miles via I-20." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at the Atlanta Passport Agency via our pre-secured courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Aiken or CSRA address — fully trackable." },
  ],
  faqs: [
    {
      q: "How far is Aiken from the Atlanta passport agency?",
      a: "Aiken is approximately 155 miles from the Atlanta Passport Agency at 230 Peachtree St NW — about a 2 hour 30 minute drive west on I-20. Aiken is one of the closest South Carolina cities to Atlanta among those without their own agency. However, the Atlanta agency still requires pre-scheduled NPIC appointments and does not accept walk-ins.",
    },
    {
      q: "Does Aiken, SC have its own passport agency?",
      a: "No. Aiken does not have a passport agency. At only 155 miles away, the Atlanta Passport Agency is the closest — about 2.5 hours via I-20. Aiken only has passport acceptance facilities — the Aiken Post Office on Laurens Street and the Aiken County Clerk of Court — which can accept your DS-11 application but cannot process or expedite it.",
    },
    {
      q: "I'm an equestrian competitor — how fast can I get a passport for an international horse show?",
      a: "Aiken's equestrian community is one of our most frequent client groups. International competitions in the UK, Germany, Netherlands, and beyond often come up with short notice during show season. Emergency processing delivers passports in 24–48 hours. Standard expedited processing runs 2–9 business days. We understand the equestrian competition calendar and work around your schedule.",
    },
    {
      q: "Where do Aiken travelers typically fly internationally?",
      a: "Most Aiken travelers use Augusta Regional Airport (AGS, about 25 miles away) for domestic connections to Atlanta (ATL) and Charlotte (CLT). For international departures, many drive directly to Hartsfield-Jackson Atlanta International (ATL, about 150 miles away) — one of the world's busiest airports with worldwide connections. Columbia Metropolitan (CAE, about 55 miles) and Charleston International (CHS, about 130 miles) are alternatives.",
    },
    {
      q: "How fast can I get an emergency passport in Aiken?",
      a: "Emergency processing is typically 24–48 hours for Aiken residents. Aiken is only 155 miles from Atlanta — one of the fastest courier routes among our South Carolina cities. The direct I-20 corridor makes overnight courier routing exceptionally efficient.",
    },
    {
      q: "Where can I get passport photos in Aiken?",
      a: "Walgreens at 2550 Whiskey Rd and CVS Pharmacy at 2101 Whiskey Rd in Aiken both offer passport photo services. UPS Store locations in Aiken also offer passport photos. Always verify your photos meet exact 2x2 inch specifications with a white background — professional equestrian photo services generally do not meet U.S. Department of State standards.",
    },
    {
      q: "Can I use the Augusta, Georgia post office if I live in Aiken?",
      a: "Yes. As a U.S. citizen, you can use any U.S. passport acceptance facility regardless of state lines. The Augusta Main Post Office at 525 8th St in Augusta, GA is only about 20 miles from Aiken and accepts passport applications. However, remember that acceptance facilities only accept applications — they cannot expedite processing. That's where Fast Passport Center's courier service to Atlanta comes in.",
    },
    {
      q: "How do I renew my passport in Aiken?",
      a: "Adult renewals meeting all DS-82 eligibility criteria (16 or older, issued within 15 years, same name) can be done entirely by mail. Fast Passport Center's courier service achieves 2–9 business day turnaround — far faster than self-service USPS (8–11 weeks). If you're not eligible for mail-in renewal, visit the Aiken Post Office or Aiken County Clerk of Court for an in-person DS-11 application.",
    },
    {
      q: "I work at Savannah River Site — does my DOE badge help with passport applications?",
      a: "No. Your DOE security clearance and SRS badge are completely separate from passport requirements. SRS contractors and employees must maintain valid personal passports for international travel. DOE credentials do not substitute for passport requirements at any international border. You need a valid U.S. passport for any international travel, regardless of your clearance level.",
    },
    {
      q: "Can Fast Passport Center help North Augusta and Edgefield residents too?",
      a: "Absolutely. We serve all of Aiken County and the CSRA including Aiken, North Augusta, Edgefield, Graniteville, Warrenville, New Ellenton, Barnwell, Williston, Bamberg, and Johnston. We also serve the Augusta, GA metro area. Residents of surrounding communities never need to drive to Aiken or Atlanta for service.",
    },
    {
      q: "Does the Aiken County Clerk of Court process passports faster than the post office?",
      a: "Both the Aiken County Clerk of Court at 109 Park Ave SE and the Aiken Post Office on Laurens Street serve as passport acceptance facilities with identical processing capabilities. The County Clerk often has shorter wait times and more flexible scheduling. However, neither facility can expedite processing beyond standard mail timelines — that's where Fast Passport Center's courier to the Atlanta agency provides dramatic speed improvements.",
    },
    {
      q: "I'm going to the UK for an equestrian event — what passport validity is required?",
      a: "The United Kingdom requires that your passport be valid for the entire duration of your stay. While the UK does not have the 6-month rule that many EU countries require, we strongly recommend at least 6 months of validity beyond your planned return date — especially for equestrian competitors who may need to extend their stay if horses are quarantined or competition schedules change. Always verify specific requirements with the event organizers.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Aiken", address: "2550 Whiskey Rd, Aiken, SC 29803", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Aiken", address: "2101 Whiskey Rd, Aiken, SC 29803", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "UPS Store — Aiken", address: "2441 Whiskey Rd, Aiken, SC 29803", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart Photo — Aiken", address: "2035 Whiskey Rd S, Aiken, SC 29803", hours: "Mon–Sun: 7AM–9PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — North Augusta", address: "1040 Edgefield Rd, North Augusta, SC 29841", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Augusta (Walton Way)", address: "1520 Walton Way, Augusta, GA 30904", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    { name: "SC DMV — Aiken", address: "1755 Richland Ave E, Aiken, SC 29801", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Primary SC DMV branch serving Aiken County and the western CSRA. REAL ID, driver's license, and state ID services for Aiken area residents.", featured: true },
    { name: "SC DMV — North Augusta", address: "1837 Knox Ave, North Augusta, SC 29841", hours: "Mon–Fri: 8:30AM–5:00PM", note: "Convenient for North Augusta and southern Aiken County residents near the Georgia border.", featured: false },
    { name: "GA DDS — Augusta South", address: "3475 Mike Padgett Hwy, Augusta, GA 30906", hours: "Tue–Sat: 7:30AM–6:00PM", note: "For CSRA residents who hold Georgia licenses. About 30 minutes from Aiken. Offers Saturday hours — rare in the area.", featured: false },
  ],
  airports: [
    {
      code: "AGS",
      name: "Augusta Regional Airport",
      distance: "25 miles southwest of Aiken",
      address: "1501 Aviation Way, Augusta, GA 30906",
      note: "Closest commercial airport to Aiken with American Eagle and Delta Connection service to Charlotte (CLT) and Atlanta (ATL) hubs. About 35 minutes via US-1/I-520. Most international travelers connect through ATL or CLT.",
      flightUrl: "https://www.flyags.com/",
      flightLabel: "AGS Airport",
      featured: true,
    },
    {
      code: "ATL",
      name: "Hartsfield-Jackson Atlanta International Airport",
      distance: "150 miles west of Aiken",
      address: "6000 N Terminal Pkwy, Atlanta, GA 30320",
      note: "World's busiest airport and the primary international gateway for Aiken travelers. Only 2 hours 15 minutes via I-20. Worldwide connections to all continents. Co-located with the Atlanta Passport Agency for emergency processing.",
      flightUrl: "https://www.atl.com/",
      flightLabel: "ATL Airport",
      featured: false,
    },
    {
      code: "CAE",
      name: "Columbia Metropolitan Airport",
      distance: "55 miles east of Aiken",
      address: "3250 Airport Blvd, West Columbia, SC 29170",
      note: "South Carolina's second-busiest airport with domestic routes via American, Delta, and United. About 1 hour via I-20. Convenient alternative for domestic connections without Atlanta traffic.",
      flightUrl: "https://flycae.com/",
      flightLabel: "CAE Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "140 miles north of Aiken",
      address: "5501 R C Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub with extensive global connections. About 2 hours 30 minutes via I-77. American Airlines hub with direct flights to Europe, Caribbean, and Latin America.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
};